import React, { useRef, useState } from 'react';
import Avatar from '@pushpay/avatar';
import { Button } from '@pushpay/button';
import Drawer from '@pushpay/drawer';
import Dropdown from '@pushpay/dropdown';
import { Carousel } from '@pushpay/layout';
import { clsx } from '@pushpay/styles';
import { ProfileDropdownProvider } from './profile-context';
import { useStyles } from './styles';
export const ProfileDropdown = function ProfileMenu(props) {
  const {
    classes: classesProp,
    'data-pp-at-target': targetId,
    alignment,
    firstName,
    isMobile = false,
    lastName,
    panels,
    profileButtonAriaLabel,
    profileId,
    profileImgUrl,
    deprecated = true,
    ...rest
  } = props;
  const [isMobileOverlayVisible, setIsMobileOverlayVisible] = useState(false);
  const classes = useStyles(classesProp);

  const avatar = active => /*#__PURE__*/React.createElement("div", {
    className: clsx(classes.avatarButtonWrapper, !deprecated && active && classes.activeAvatar)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.avatarButton
  }, /*#__PURE__*/React.createElement(Avatar, {
    className: classes.avatar,
    id: profileId,
    name: [firstName, lastName],
    imgUrl: profileImgUrl,
    "data-pp-at-target": `${targetId}-avatar`
  })));

  const renderOverlay = close => /*#__PURE__*/React.createElement("div", Object.assign({
    className: classes.overlayContent
  }, rest), /*#__PURE__*/React.createElement(ProfileDropdownProvider, {
    close: close
  }, /*#__PURE__*/React.createElement(Carousel, {
    carouselItems: panels
  })));

  const buttonRef = useRef(null);

  if (isMobile) {
    return /*#__PURE__*/React.createElement("div", {
      className: clsx(classes.root)
    }, /*#__PURE__*/React.createElement(Button, {
      ref: buttonRef,
      displayStyle: "unstyled",
      type: "button",
      onClick: () => setIsMobileOverlayVisible(current => !current),
      "data-pp-at-target": `${targetId}-avatar-button-mobile`,
      "aria-label": profileButtonAriaLabel
    }, avatar(isMobileOverlayVisible)), /*#__PURE__*/React.createElement(Drawer, {
      classes: {
        drawer: classes.drawerMobile,
        mask: classes.drawerMobile
      },
      visible: isMobileOverlayVisible,
      onClose: () => setIsMobileOverlayVisible(false),
      closeOnClickOutside: [buttonRef],
      placement: "right",
      "data-pp-at-target": `${targetId}-mobile-overlay`
    }, renderOverlay(() => setIsMobileOverlayVisible(false))));
  }

  return /*#__PURE__*/React.createElement(Dropdown, Object.assign({
    classes: {
      root: classes.root,
      overlay: classes.overlay
    },
    "data-pp-at-target": `${targetId}-avatar-button`,
    hideDropdownArrow: true,
    alignment: alignment,
    overlay: renderOverlay,
    closeOverlayOnEnter: false,
    title: profileButtonAriaLabel,
    "aria-label": profileButtonAriaLabel
  }, rest), isOpen => avatar(isOpen));
};